import { render } from "./bugReport.vue?vue&type=template&id=88dd4f24&scoped=true"
import script from "./bugReport.vue?vue&type=script&lang=js"
export * from "./bugReport.vue?vue&type=script&lang=js"

import "./bugReport.vue?vue&type=style&index=0&id=88dd4f24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88dd4f24"]])

export default __exports__